module.exports = __webpack_public_path__ + "static/media/MM50-1MTJ.361b0557.png";